import { useMemo } from 'react';

import getDeviceLocation from '@utils/get-device-location';
import getPostcode from '@services/get-postcode';

const useGetLocationHookFactory =
  ({ getLocationFn = getDeviceLocation, getPostcodeFn = getPostcode } = {}) =>
  ({ onUpdateLoading, onSuccess }) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useMemo(
      () => async () => {
        onUpdateLoading(true);
        const location = await getLocationFn();
        const postcode = await getPostcodeFn(location);
        onSuccess(postcode);
        onUpdateLoading(false);
      },
      [onUpdateLoading, onSuccess],
    );
  };

export default useGetLocationHookFactory;
